import { useContext, useState } from "react";
import { Box, Typography } from "@mui/material";
import { Avatar } from "@benefit-systems/hr-tools-ui";
import { useReactFlow, NodeProps } from "@xyflow/react";
import { useFormContext } from "react-hook-form";
import OrgchartAsManagerIcon from "src/Pages/Company/OrganizationStructure/assets/icons/DefaultOrgchartManagerIcon.svg";
import orgChartContext from "src/Pages/Company/OrganizationStructure/context/OrgchartContext";
import useSearchedNodesStyles from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/Areas/useSearchedNodesStyles";
import useOrgchartAreasStore from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/Areas/store";
import { TEmployeeNode } from "./customNodes.models";
import BottomHandle from "./shared-components/BottomHandle";
import TopHandle from "./shared-components/TopHandle";

const RootNode = ({ data, id: nodeId }: NodeProps<TEmployeeNode>) => {
  const { edges, setNodeToFocusOn } = useOrgchartAreasStore();
  const { changeNodesVisibility } = useContext(orgChartContext);
  const { resetField } = useFormContext();
  const flow = useReactFlow();
  const clickedNodeParentId = flow.getNode(nodeId)?.data.parentId as string;
  const [isClickedNodeCollapsed, setIsClickedNodeCollapsed] = useState<boolean>(
    useOrgchartAreasStore
      .getState()
      .childrenCollapsedStatus.get(clickedNodeParentId) as boolean
  );

  const searchedStyles = useSearchedNodesStyles(nodeId);

  const handleClick = () => {
    setIsClickedNodeCollapsed(!isClickedNodeCollapsed);
    resetField("autocomplete", { defaultValue: "" });
    changeNodesVisibility({
      isClickedNodeCollapsed,
      clickedNodeId: nodeId,
      edges,
    });
    setNodeToFocusOn({
      id: nodeId,
      isCollapsed: !isClickedNodeCollapsed,
    });
  };

  return (
    <div style={{ opacity: searchedStyles.opacity }}>
      <TopHandle />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "24px",
          borderRadius: "12px",
          padding: "16px 16px 24px 16px",
          width: "340px",
          minWidth: "340px",
          maxWidth: "340px",
          border: searchedStyles.border,
        }}
      >
        <Box>
          {data.avatar ? (
            <Avatar size={13} src={data.avatar}>
              {data.initials || ""}
            </Avatar>
          ) : (
            <Box
              sx={{
                height: "52px",
                width: "52px",
                backgroundColor: "#bdbdbd",
                borderRadius: "100%",
                padding: "6px",
              }}
            >
              <img
                style={{ maxWidth: "100%" }}
                src={OrgchartAsManagerIcon}
                alt="ManagerDefaultIcon"
              />
            </Box>
          )}
        </Box>
        <Typography
          color="textPrimary"
          variant="subtitle2"
          sx={{ fontWeight: "fontWeightMedium", textAlign: "center" }}
        >
          {data.name}
        </Typography>
      </div>
      {data.hasChildren ? (
        <BottomHandle
          handleClick={handleClick}
          isClickedNodeCollapsed={isClickedNodeCollapsed}
        />
      ) : null}
    </div>
  );
};

export default RootNode;
